import PropTypes from 'prop-types';
import {getNextThemeIcon} from '../utils/theme';
import AccountMenu from './AccountMenu';

function CheckboxLogo() {
    return (
        <svg width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="7" fill="currentColor"/>
            <rect x="7" y="7" width="18" height="18" rx="3.5" fill="none" stroke="var(--checkmark)" strokeWidth="2"/>
            <polyline points="11,16 14.5,20 21,12" fill="none" stroke="var(--checkmark)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

function HamburgerIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line x1="2" y1="4" x2="14" y2="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="2" y1="8" x2="14" y2="8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="2" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
}

export default function Header({theme, onToggleTheme, onLogout, username, onAccountSettings, onLogoClick, onToggleSidebar, sidebarOpen, currentViewLabel}) {
    const nextIcon = getNextThemeIcon(theme);
    const isAuthenticated = !!(onLogout && username);
    return (
        <div className="app-header">
            {onToggleSidebar && (
                <button className="header-hamburger" onClick={onToggleSidebar} aria-label={sidebarOpen ? 'Close navigation' : 'Open navigation'}>
                    <HamburgerIcon />
                </button>
            )}
            <button className="header-logo" onClick={onLogoClick} aria-label="Go to home">
                <CheckboxLogo/>
                <span className="header-wordmark">CHECKLISTS GURU</span>
            </button>
            {currentViewLabel && (
                <span className="header-current-view">{currentViewLabel}</span>
            )}
            <div className="app-header-right">
                {isAuthenticated ? (
                    <AccountMenu
                        username={username}
                        onLogout={onLogout}
                        onAccountSettings={onAccountSettings}
                        theme={theme}
                        onToggleTheme={onToggleTheme}
                    />
                ) : (
                    <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
                        {nextIcon}
                    </button>
                )}
            </div>
        </div>
    );
}

Header.propTypes = {
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
    onLogout: PropTypes.func,
    username: PropTypes.string,
    onAccountSettings: PropTypes.func,
    onLogoClick: PropTypes.func.isRequired,
    onToggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    currentViewLabel: PropTypes.string,
};
